<template>
  <div class="companies">
      <v-app id="inspire">
    <v-card color="basil">
      <v-card-title class="text-center justify-center py-6">
        <h1 class="font-weight-bold display-3 basil--text">Companies</h1>
      </v-card-title>
  
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="basil"
        grow
      >
        <v-tab
          v-for="item in items"
          :to="item.path"
          :key="item.title"
        >
          {{ item.title }}
        </v-tab>
      </v-tabs>
      <router-view />
      
    </v-card>
  </v-app>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tab: null,
      items: [
          { title: 'Trial license companies', path: "/app/companies/trial" },
          { title: 'Full license companies', path: "/app/companies/full" }
      ],
    }
  },
}
</script>